import { Body, IconButton, Tooltip } from '@assembly-js/design-system';
import { Menu, MenuItem } from '@material-ui/core';
import clsx from 'clsx';
import { useState } from 'react';

import { Action } from 'src/constants';

const MenuItemContent = ({
  action,
  onClose,
}: {
  action: Action;
  onClose: () => void;
}) => {
  const { name, onClick, icon, isDelete, isDisabled, classes } = action;

  const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    if (isDisabled) return;
    onClick(e);
    onClose();
  };

  const menuItem = (
    <MenuItem
      data-testid={`action-${name}`}
      onClick={handleClick}
      disabled={isDisabled}
      className={clsx(
        'flex items-center gap-4',
        {
          'text-black-heading': isDisabled,
          'text-red-primary hover:!text-red-primary': isDelete && !isDisabled,
        },
        classes,
      )}
    >
      {icon}
      <Body size="sm">{name}</Body>
    </MenuItem>
  );

  if (isDisabled && action.tooltipLabel) {
    return (
      <Tooltip
        content={<Body size="sm">{action.tooltipLabel}</Body>}
        position="left"
      >
        <div>{menuItem}</div>
      </Tooltip>
    );
  }

  return menuItem;
};

export const MenuAction = ({ actions }: { actions: Action[] }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <div>
      <IconButton
        variant="minimal"
        icon="Ellipsis"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="hover:bg-[#F1F3F8] text-gray-small p-1 [&_svg]:w-5 [&_svg]:h-5"
      />
      <Menu
        classes={{
          paper: 'min-w-[160px]',
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
      >
        {actions.map((action) => (
          <MenuItemContent
            key={action.key ?? action.name}
            action={action}
            onClose={() => setAnchorEl(null)}
          />
        ))}
      </Menu>
    </div>
  );
};
